<template>
    <main id="mainCtrl">
        <ClinicEdit ref="clinicEditDialog" />
        <v-table id="table"
                 request-uri="clinics/getList"
                 pagesize="50"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="city" sort="city" width="45">
                        Город
                    </v-th>
                    <v-th name="img" width="50">
                        Лого
                    </v-th>
                    <v-th name="nameOrAddress" sort="clinics.name" minwidth="150">
                        Название
                    </v-th>
                    <v-th name="subscriptionTariff" tooltip="Тариф" width="50">
                        <i class="fas fa-up"></i>
                    </v-th>
                    <v-th name="type" sort="clinics.types" minwidth="150">
                        Категории
                    </v-th>
                    <v-th name="doctors_count" sort="doctors_count" tooltip="Врачей в клинике" width="60">
                        Врачи
                    </v-th>
                    <v-th name="url" sort="url" minwidth="100">
                        URL
                    </v-th>
                    <v-th name="rating" sort="rating"  tooltip="Рейтинг" width="50">
                        <i class="fas fa-star-half-alt"></i>
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="city" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...cityOptions
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="img" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">

                        </v-select>
                    </v-th>
                    <v-th name="nameOrAddress" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="subscriptionTariff" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "*",
                                    text: "Вкл"
                                },
                                {
                                    value: "-",
                                    text: "Выкл"
                                }
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="type" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    text: "\u00a0",
                                    value: ""
                                },
                                ...Object.values(clinicTypes)
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="doctors_count" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: ">0",
                                    text: "Есть врачи"
                                },
                                {
                                    value: "=0",
                                    text: "0 врачей"
                                }
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="url" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="rating" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "-",
                                    text: "- нет"
                                },
                                {
                                    value: "1",
                                    text: "1 ★☆☆☆☆"
                                },
                                {
                                    value: "2",
                                    text: "2 ★★☆☆☆"
                                },
                                {
                                    value: "3",
                                    text: "3 ★★★☆☆"
                                },
                                {
                                    value: "4",
                                    text: "4 ★★★★☆"
                                },
                                {
                                    value: "5",
                                    text: "5 ★★★★★"
                                }
                            ]'
                        ></v-select>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr :class="['hover', 'pointer', {'warning': item.moderationNeeded}]" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="city" highlight="*" width="45">
                        <span v-if="item.cityObj !== null" v-tooltip="item.cityObj.name">{{ item.cityObj.name_info.short }}</span>
                    </v-td>
                    <v-td name="img" width="45">
                        <img v-if="Object.keys(item.img).length" width="40" :src="item.img.little" alt="">
                    </v-td>
                    <v-td name="nameOrAddress" minwidth="150">
                        {{ item.name }}
                        <div>{{item.address}}</div>
                    </v-td>
                    <v-td name="subscriptionTariff" align="center" width="50">
                        <i v-if="item.subscription"
                           class="fas fa-up text-success"
                           v-tooltip="tariffs[item.subscription.tariff]"/>
                        <i v-else class="far fa-minus text-danger" v-tooltip="'Без тарифа'"></i>
                    </v-td>
                    <v-td name="type" minwidth="150" :highlight="searchTypeValue">
                        {{item.typesAsText}}
                    </v-td>
                    <v-td name="doctors_count" width="60"  align="center">{{item.doctors_count}}</v-td>
                    <v-td name="url" minwidth="100">
                        <a class="text-ellipsis"
                           @click.prevent.stop="openHref(`${$parent.frontendUrl}/${item.city}/clinic/${item.url}`)"
                            v-tooltip="`${$parent.frontendUrl}<br/>/${item.city}/clinic/${item.url}`"
                           :href="`${$parent.frontendUrl}/${item.city}/clinic/${item.url}`" target="_blank">
                            {{ item.url }}
                        </a>
                    </v-td>
                    <v-td name="rating" width="50" align="center" highlight="*">
                        {{ (Math.round(item.rating * 5 * 10) / 10).toFixed(1) }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
    import ClinicEdit from "./ClinicEditDialog";
    import {mapState} from "vuex";

    export default {
        components: {
            ClinicEdit
        },
        props: {
            cityOptions: {
                type: Array,
                required: true
            },
            clinicTypes: {
                type: Array,
                required: true
            },
        },
        data: function () {
            return {
                tariffs: {
                    ABONEMENT: 'Подписка Стандарт',
                    ABONEMENT_PLUS: 'Подписка Премиум',
                    ONLY_LK: 'Личный кабинет',
                }
            };
        },
        mounted: function () {
            this.$refs.table.update();
        },
        methods: {
            handleRowClick: function (event, row, item) {
                row.startLoadingAnimation();

                return this.readAccount(item.id, event, row);
            },
            onUpdatedEvent () {
                this.$refs.table.update();
            },
            readAccount: function (clinicId, e, row) {
                this.$refs.clinicEditDialog
                    .read(clinicId, e)
                    .then(() => row.stopLoadingAnimation(), () => row.stopLoadingAnimation());
            },

            openHref(href) {
                window.open(href)
            },
        },
        computed: {
          ...mapState({
            currentUser: state => state.currentUser,
          }),
            striptagsTrimNoHttp () {
                return "striptags trim nohttp";
            },
            searchTypeValue: function () {
                let foundType = Object.entries(this.clinicTypes).filter(val => {
                    return val[1].value === this.$refs.table.filter.type;
                });

                return foundType !== undefined && foundType.length > 0 ? foundType[0][1].text : '';
            }
        }
    }
</script>
